import { render, staticRenderFns } from "./AIMassnahmen.vue?vue&type=template&id=5a5955ed&scoped=true"
import script from "./AIMassnahmen.vue?vue&type=script&lang=js"
export * from "./AIMassnahmen.vue?vue&type=script&lang=js"
import style0 from "./AIMassnahmen.vue?vue&type=style&index=0&id=5a5955ed&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a5955ed",
  null
  
)

export default component.exports